import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '../../../app/providers/useAuth';
import { updateTask, type UpdateTaskPatch } from '../api/tasksApi';

interface UpdateTaskParams {
  taskId: number;
  patch: UpdateTaskPatch;
}

// PARA-128 — редактирование задачи; инвалидирует ['tasks', userId] (+ subtasks
// родителя, если это подзадача) по образцу useChangeTaskStatus.
export function useUpdateTask() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ taskId, patch }: UpdateTaskParams) => updateTask(taskId, patch),
    onSuccess: (task) => {
      void queryClient.invalidateQueries({ queryKey: ['tasks', user?.id] });
      if (task.parent_task_id !== null) {
        void queryClient.invalidateQueries({
          queryKey: ['tasks', user?.id, task.parent_task_id, 'subtasks'],
        });
      }
    },
  });
}
